import { ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class OnboardingStep extends ModelBase {

    public onboardingStepId: number = 0;

    public stepName: number = 0;
}